/** Compare two semver-like "x.y.z" strings numerically. Returns:
 *    1  if a > b
 *    0  if equal
 *   -1  if a < b
 *  null if either string isn't parseable as 3 numeric components.
 *
 *  Pre-release tags (e.g. "1.0.0-beta.1") are not supported — they fall
 *  through to null, which callers treat as "use exact-match equality".
 *  Plugin manifest versions and CLI versions in DOSIA today are all
 *  release semver, so this covers every real path.
 *
 *  Lives in @dosia/shared so both `core` (compat resolver) and `apps/
 *  desktop` (recommended-plugins seed) can import the same logic without
 *  duplication. Keep this implementation minimal — pulling in the full
 *  `semver` npm package costs ~50KB for behavior we don't need. */
export function compareSemver(a, b) {
    const parse = (v) => {
        const m = /^(\d+)\.(\d+)\.(\d+)$/.exec(v);
        return m ? [Number(m[1]), Number(m[2]), Number(m[3])] : null;
    };
    const pa = parse(a);
    const pb = parse(b);
    if (!pa || !pb)
        return null;
    for (let i = 0; i < 3; i++) {
        if (pa[i] > pb[i])
            return 1;
        if (pa[i] < pb[i])
            return -1;
    }
    return 0;
}
//# sourceMappingURL=semver.js.map